import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { IoIosCheckmarkCircle } from "react-icons/io";

const PasswordUpdated = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!location.state?.fromReset) {
            navigate("/", { replace: true });
        }
    }, []);

    return (
        <div className="min-h-[85vh] bg-white dark:bg-[#1E1D21] flex flex-col items-center justify-center p-4">
            <IoIosCheckmarkCircle className="h-12 w-12 text-cyan-600 dark:text-cyan-400" />
            <h1 className="mt-6 text-xl font-bold text-black dark:text-white">
                Password updated
            </h1>
            <p className="mt-2 px-10 text-center text-[13px] font-semibold text-gray-600 dark:text-gray-300">
                You can now log in with your new password.
            </p>
            <button
                type="button"
                onClick={() => navigate("/login")}
                className="mt-8 h-12 w-full rounded-xl bg-[#BDE6FF] text-black  font-semibold shadow-sm hover:bg-[#a6dbfa] transition-colors"
            >
                Log in
            </button>
        </div>
    );
};

export default PasswordUpdated;
